import {useState} from "react";

import {Alert} from "@/components/alert/Alert.tsx";
import {useCheckoutContext, useCurrentUserContext} from "@/components/context/hooks.ts";
import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {PaymentMethodDisplay} from "@/pages/billing/payment-method/PaymentMethodDisplay.tsx";
import {PaymentMethodEdit} from "@/pages/billing/payment-method/PaymentMethodEdit.tsx";

interface PaymentMethodProps {
  readOnly?: boolean;
  withButtons?: boolean;
  formId?: string;
  onSuccess?: () => void;
  allowEmpty?: boolean;
  subscription?: boolean;
  variant: "modal" | "inline";
}

export const PaymentMethod = ({
  readOnly,
  withButtons,
  formId,
  onSuccess,
  allowEmpty,
  subscription,
  variant,
}: PaymentMethodProps) => {
  const {user} = useCurrentUserContext();
  const {requestInProgress, setRequestInProgress, paymentMethod, billingData, braintreeToken} = useCheckoutContext();
  const [edit, setEdit] = useState(!allowEmpty && !paymentMethod?.pm_type && variant === "inline");
  const initialSubscription = !paymentMethod?.type;

  if (edit) {
    if (readOnly) {
      return false;
    }
    if (variant === "modal") {
      return (
        <FormModal
          show={edit}
          size={"lg"}
          onCancel={() => setEdit(false)}
          formId={formId}
          disabled={requestInProgress}
          submitBtnText={requestInProgress ? "Working..." : "Save"}
          title={paymentMethod?.pm_type ? "Update payment method" : "Add payment method"}
        >
          <Alert size="small" show={!user?.is_primary && user?.has_admin_access && initialSubscription}>
            <p className="text-center m-0">You will take ownership of the account after adding a payment method.</p>
          </Alert>
          <PaymentMethodEdit
            billingData={billingData || {}}
            braintreeToken={braintreeToken || ""}
            onCancel={() => setEdit(false)}
            onSuccess={() => {
              setEdit(false);
              if (onSuccess) {
                setRequestInProgress(false);
                onSuccess();
              }
            }}
            withButtons={false}
            withCancelButton={false}
            subscription={false}
            formId={formId}
          />
        </FormModal>
      );
    } else {
      return (
        <PaymentMethodEdit
          billingData={billingData || {}}
          braintreeToken={braintreeToken || ""}
          onCancel={() => setEdit(false)}
          onSuccess={() => {
            setEdit(false);
            if (onSuccess) {
              onSuccess();
            }
          }}
          withButtons={withButtons}
          withCancelButton={true}
          subscription={subscription}
          formId={formId}
        />
      );
    }
  }
  return (
    <PaymentMethodDisplay
      paymentMethod={paymentMethod}
      readOnly={readOnly}
      onEdit={() => setEdit(true)}
      formId={formId}
      onSuccess={() => {
        if (onSuccess) {
          onSuccess();
        }
      }}
    />
  );
};
